/* tslint:disable */
/* eslint-disable */
/**
 * Core Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

/**
 * 
 * @export
 * @interface Name
 */
export interface Name  {
    /**
     * 
     * @type {string}
     * @memberof Name
     */
    family?: string;
    /**
     * 
     * @type {string}
     * @memberof Name
     */
    given?: string;
    /**
     * 
     * @type {string}
     * @memberof Name
     */
    dropping_particle?: string;
    /**
     * 
     * @type {string}
     * @memberof Name
     */
    non_dropping_particle?: string;
    /**
     * 
     * @type {string}
     * @memberof Name
     */
    suffix?: string;
    /**
     * 
     * @type {any}
     * @memberof Name
     */
    comma_suffix?: any | null;
    /**
     * 
     * @type {any}
     * @memberof Name
     */
    static_ordering?: any | null;
    /**
     * 
     * @type {string}
     * @memberof Name
     */
    literal?: string;
    /**
     * 
     * @type {any}
     * @memberof Name
     */
    parse_names?: any | null;
}

/**
 * Check if a given object implements the Name interface.
 */
export function instanceOfName(value: object): value is Name {
    return true;
}

export function NameFromJSON(json: any): Name {
    return NameFromJSONTyped(json, false);
}

export function NameFromJSONTyped(json: any, ignoreDiscriminator: boolean): Name {
    if (json == null) {
        return json;
    }
    return {
        
                  'family': json['family'] == null ? undefined : json['family'],
                  'given': json['given'] == null ? undefined : json['given'],
                  'dropping_particle': json['dropping-particle'] == null ? undefined : json['dropping-particle'],
                  'non_dropping_particle': json['non-dropping-particle'] == null ? undefined : json['non-dropping-particle'],
                  'suffix': json['suffix'] == null ? undefined : json['suffix'],
                  'comma_suffix': json['comma-suffix'] == null ? undefined : json['comma-suffix'],
                  'static_ordering': json['static-ordering'] == null ? undefined : json['static-ordering'],
                  'literal': json['literal'] == null ? undefined : json['literal'],
                  'parse_names': json['parse-names'] == null ? undefined : json['parse-names'],
    };
}

export function NameToJSON(json: any): Name {
    return NameToJSONTyped(json, false);
}

export function NameToJSONTyped(value?: Name | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'family': value['family'],
        'given': value['given'],
        'dropping-particle': value['dropping_particle'],
        'non-dropping-particle': value['non_dropping_particle'],
        'suffix': value['suffix'],
        'comma-suffix': value['comma_suffix'],
        'static-ordering': value['static_ordering'],
        'literal': value['literal'],
        'parse-names': value['parse_names'],
    };
}


